import React from 'react'
import Eyebrow from 'src/images/svgs/Eyebrow.svg'
import * as Styles from './linkGrid.module.scss'

export type GridContent = {
  anchor?: string
  heading?: string
  links?: any[]
}

type Props = {
  content: GridContent
}

type Link = {
  link_text: string
  link_url: string
}

const LinkGrid = ({ content }: Props) => {
  const { anchor, heading = '', links } = content

  return (
    <section id={anchor} className={Styles.linkGrid}>
      <div>{heading && <h2>{heading}</h2>}</div>
      <ol className={Styles.linksOuter}>
        {links &&
          links?.map((link: Link) => (
            <li className={Styles.linkContainer}>
              <a
                className={Styles.linkHref}
                key={link.link_text}
                href={link.link_url}
                aria-label={link.link_text}
              >
                <Eyebrow className={Styles.eyebrow} />
                <span className={Styles.linkText}>{link.link_text}</span>
                <span className={Styles.linkArrow}>
                  <span />
                </span>
              </a>
            </li>
          ))}
      </ol>
    </section>
  )
}

export default LinkGrid
